import React from "react";
import PropTypes from "prop-types";
import utils from "@utils";
import { Modal } from "../../../../components";

const MissingTimecardModal = props => {
	const { lang } = global;
	const {
		settings: { show, items },
		timeZone,
		onSuccess,
		onCancel,
	} = props;
	const noTcItems = items.filter(({ TimeCard }) => TimeCard === null);

	return (
		<Modal
			id="missing-timecard-modal"
			show={show}
			onHide={() => onCancel()}
		>
			<Modal.Header>
				<Modal.Title>{lang.t("No Timecards")}</Modal.Title>
			</Modal.Header>
			<Modal.Body>
				<div className="row text-center">
					<p className="col-sm-12">
						{lang.t("The following items do not have timecard entries")}:
					</p>
				</div>
				<div className="row hidden-xs">
					<div className="col-sm-4">
						<strong>{lang.t("Job")}</strong>
					</div>
					<div className="col-sm-4">
						<strong>
							{lang.t("Start Date")} &amp; {lang.t("Time")}
						</strong>
					</div>
					<div className="col-sm-4">
						<strong>{lang.t("Officer")}</strong>
					</div>
				</div>
				<For
					each="item"
					of={noTcItems}
				>
					<div
						className="row no-timecard"
						key={`assignment_${item.JobAssignmentId}`}
					>
						<div
							className="col-sm-4"
							title={item.JobEventTitle}
						>
							{`${item.JobEventTitle} (${item.JobEventId})`}
						</div>
						<div className="col-sm-4">
							{utils.formatDate(new Date(`${item.JobStartTime}Z`), "en-US", timeZone)}
							<span className="visible-xs-inline">&nbsp;</span>
							<br className="hidden-xs" />
							{utils.formatTime(new Date(`${item.JobStartTime}Z`), true, timeZone)}
						</div>
						<div className="col-sm-4">{item.OfficerName}</div>
					</div>
				</For>
				<div className="row text-center">
					<div className="col-sm-12">
						{lang.t("Do you want to continue invoicing these jobs_")}
					</div>
				</div>
			</Modal.Body>
			<Modal.Footer>
				<button
					type="button"
					className="btn btn-link"
					onClick={() => onCancel()}
				>
					{lang.t("Cancel")}
				</button>
				<button
					type="button"
					className="btn btn-primary"
					onClick={() => onSuccess()}
				>
					{lang.t("Continue")}
				</button>
			</Modal.Footer>
		</Modal>
	);
};

MissingTimecardModal.propTypes = {
	settings: PropTypes.shape({
		show: PropTypes.bool,
		items: PropTypes.array,
		updatingLineItems: PropTypes.bool,
	}),
	timeZone: PropTypes.string,
	onSuccess: PropTypes.func,
	onCancel: PropTypes.func,
};

MissingTimecardModal.defaultProps = {
	settings: { show: false, items: [], updatingLineItems: false },
	timeZone: undefined,
	onSuccess: () => {},
	onCancel: () => {},
};

export default MissingTimecardModal;
